var _path, _g, _g2, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyMessagesTemplate1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 178,
    viewBox: "0 0 178 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9557 23C132.62 23 168.427 54.6883 168.427 96.3529C168.427 134.536 129.139 156 90.9557 156C51.3709 156 9 135.938 9 96.3529C9 53.3999 48.0027 23 90.9557 23Z",
    fill: "url(#paint0_linear_6216_307)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_6216_307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.939 115.422H16.6895C13.6174 115.422 11.127 117.912 11.127 120.984V148.797C11.127 151.869 13.6174 154.359 16.6895 154.359H127.939C131.012 154.359 133.502 151.869 133.502 148.797V120.984C133.502 117.912 131.012 115.422 127.939 115.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3457 134.891H19.4707C17.9347 134.891 16.6895 136.136 16.6895 137.672C16.6895 139.208 17.9347 140.453 19.4707 140.453H97.3457C98.8817 140.453 100.127 139.208 100.127 137.672C100.127 136.136 98.8817 134.891 97.3457 134.891Z",
    fill: "#D1D3D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6113 143.234H19.4707C17.9347 143.234 16.6895 144.48 16.6895 146.016C16.6895 147.552 17.9347 148.797 19.4707 148.797H87.6113C89.1474 148.797 90.3926 147.552 90.3926 146.016C90.3926 144.48 89.1474 143.234 87.6113 143.234Z",
    fill: "#D1D3D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3145 122.375H30.5957C29.0597 122.375 27.8145 123.62 27.8145 125.156C27.8145 126.692 29.0597 127.938 30.5957 127.938H72.3145C73.8505 127.938 75.0957 126.692 75.0957 125.156C75.0957 123.62 73.8505 122.375 72.3145 122.375Z",
    fill: "#D1D3D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.549 134.891H115.424C114.656 134.891 114.033 135.513 114.033 136.281V147.406C114.033 148.174 114.656 148.797 115.424 148.797H126.549C127.317 148.797 127.939 148.174 127.939 147.406V136.281C127.939 135.513 127.317 134.891 126.549 134.891Z",
    fill: "#6940F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6426 120.984H18.0801C17.3121 120.984 16.6895 121.607 16.6895 122.375V127.938C16.6895 128.706 17.3121 129.328 18.0801 129.328H23.6426C24.4106 129.328 25.0332 128.706 25.0332 127.938V122.375C25.0332 121.607 24.4106 120.984 23.6426 120.984Z",
    fill: "#0ACD95"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_6216_307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.314 29.2031H89.002C85.9299 29.2031 83.4395 31.6935 83.4395 34.7656V101.516C83.4395 104.588 85.9299 107.078 89.002 107.078H161.314C164.387 107.078 166.877 104.588 166.877 101.516V34.7656C166.877 31.6935 164.387 29.2031 161.314 29.2031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.752 37.5469H94.5645C93.0284 37.5469 91.7832 38.7921 91.7832 40.3281V70.9219C91.7832 72.4579 93.0284 73.7031 94.5645 73.7031H155.752C157.288 73.7031 158.533 72.4579 158.533 70.9219V40.3281C158.533 38.7921 157.288 37.5469 155.752 37.5469Z",
    fill: "white",
    stroke: "#D1D3D8",
    strokeWidth: 1.39063,
    strokeLinecap: "round",
    strokeDasharray: "2.78 2.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.846 23.6406H75.0957C73.5597 23.6406 72.3145 24.8858 72.3145 26.4219V57.0156C72.3145 58.5517 73.5597 59.7969 75.0957 59.7969H141.846C143.382 59.7969 144.627 58.5517 144.627 57.0156V26.4219C144.627 24.8858 143.382 23.6406 141.846 23.6406Z",
    fill: "url(#paint1_linear_6216_307)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M120.986 36.3343C120.986 32.3959 117.681 29.2031 113.604 29.2031C111.451 29.2031 109.513 30.0931 108.164 31.5131L78.0383 64.9619L101.5 59.6963L119.624 40.4627C120.482 39.2977 120.986 37.8728 120.986 36.3343Z",
    fill: "url(#paint2_linear_6216_307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.925 36.4868C120.925 40.5095 117.664 43.7705 113.641 43.7705C109.618 43.7705 106.357 40.5095 106.357 36.4868C106.357 32.4641 109.618 29.2031 113.641 29.2031C117.664 29.2031 120.925 32.4641 120.925 36.4868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.229 79.2656H91.0879C89.9359 79.2656 89.002 80.1995 89.002 81.3516C89.002 82.5036 89.9359 83.4375 91.0879 83.4375H159.229C160.381 83.4375 161.314 82.5036 161.314 81.3516C161.314 80.1995 160.381 79.2656 159.229 79.2656Z",
    fill: "#D1D3D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.322 86.2188H91.0879C89.9359 86.2188 89.002 87.1527 89.002 88.3047C89.002 89.4567 89.9359 90.3906 91.0879 90.3906H145.322C146.474 90.3906 147.408 89.4567 147.408 88.3047C147.408 87.1527 146.474 86.2188 145.322 86.2188Z",
    fill: "#D1D3D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.861 95.9531H90.3926C89.6246 95.9531 89.002 96.5757 89.002 97.3438V100.125C89.002 100.893 89.6246 101.516 90.3926 101.516H109.861C110.629 101.516 111.252 100.893 111.252 100.125V97.3438C111.252 96.5757 110.629 95.9531 109.861 95.9531Z",
    fill: "#6940F2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8145 36.1562H61.1895",
    stroke: "#0ACD95",
    strokeWidth: 1.39063,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8145 47.2812H61.1895",
    stroke: "#0ACD95",
    strokeWidth: 1.39063,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7207 41.7188H63.9707",
    stroke: "#0ACD95",
    strokeWidth: 1.39063,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.611 159.922C151.42 159.909 151.236 159.846 151.078 159.738C150.935 159.62 150.832 159.46 150.783 159.281C149.754 155.42 149.074 154.743 145.271 153.792C145.086 153.735 144.92 153.627 144.794 153.48C144.685 153.325 144.627 153.14 144.627 152.951C144.627 152.762 144.685 152.575 144.794 152.419C144.917 152.273 145.084 152.171 145.271 152.127C149.148 151.103 149.828 150.425 150.783 146.637C150.765 146.584 150.765 146.526 150.783 146.473C150.823 146.364 150.894 146.269 150.986 146.199C151.071 146.111 151.179 146.047 151.298 146.016H151.83C151.942 146.045 152.042 146.102 152.125 146.18C152.218 146.254 152.293 146.348 152.345 146.455V146.619C153.374 150.461 154.054 151.139 157.857 152.109H158.023C158.174 152.165 158.3 152.276 158.372 152.419C158.466 152.554 158.518 152.713 158.519 152.877C158.537 152.967 158.537 153.061 158.519 153.152C158.479 153.257 158.423 153.356 158.354 153.444C158.27 153.522 158.177 153.589 158.078 153.646H157.913C154.054 154.671 153.374 155.348 152.401 159.135C152.377 159.335 152.286 159.522 152.143 159.665C152 159.808 151.812 159.898 151.611 159.922ZM25.0332 22.25C26.5693 22.25 27.8145 21.0048 27.8145 19.4688C27.8145 17.9327 26.5693 16.6875 25.0332 16.6875C23.4971 16.6875 22.252 17.9327 22.252 19.4688C22.252 21.0048 23.4971 22.25 25.0332 22.25Z",
    fill: "#D1D3D8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_6216_307",
    x: 2.7832,
    y: 112.641,
    width: 139.063,
    height: 55.625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.5625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.17188
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6216_307"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.39063
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.08594
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_6216_307",
    result: "effect2_dropShadow_6216_307"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_6216_307",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_6216_307",
    x: 63.9707,
    y: 20.8594,
    width: 111.25,
    height: 100.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.5625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.17188
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6216_307"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.39063
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.08594
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_6216_307",
    result: "effect2_dropShadow_6216_307"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_6216_307",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6216_307",
    x1: 88.7137,
    y1: 23,
    x2: 88.7137,
    y2: 156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D3D8",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6216_307",
    x1: 108.471,
    y1: 23.6406,
    x2: 108.471,
    y2: 59.7969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A893FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6940F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6216_307",
    x1: 117.857,
    y1: 31.2891,
    x2: 88.1458,
    y2: 61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMessagesTemplate1);
export default __webpack_public_path__ + "static/media/empty_messages_template 1.9d33c92d65b4d45dc25010cd78c06b47.svg";
export { ForwardRef as ReactComponent };